import { Page } from 'ui';

import { InspectionDetails } from '../../components/InspectionDetails/InspectionDetails';

export const InspectionCreate = () => {
  return (
    <Page>
      <InspectionDetails />
    </Page>
  );
};
